export const GIFT_PARAM = 'gift'
export const MULTI_GIFT_PARAM = 'multigift'
export const PRODUCT_ID_PARAM = 'product_id'
